import { Component, Inject, OnInit, OnDestroy, NgZone, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { log } from 'console';
import { firstValueFrom, interval, Subscription, switchMap } from 'rxjs';
import { EventService } from 'src/app/core/services/event.service';

@Component({
  selector: 'app-branding-progress-dialog',
  templateUrl: './branding-progress-dialog.component.html',
  styleUrls: ['./branding-progress-dialog.component.css']
})


export class BrandingProgressDialogComponent implements OnInit, OnDestroy {
  progress = 0;
  processed = 0;
  skipped = 0;
  total = 0;
  progressStatus: 'pending' | 'processing' | 'done' = 'pending';
  polling: Subscription | any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { eventId: string },
    public dialogRef: MatDialogRef<BrandingProgressDialogComponent>,
    private api: EventService, private ngZone: NgZone, private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.startPolling();
  }

  ngOnDestroy() {
    if (this.polling) this.polling.unsubscribe();
  }

  async fetchProgress() {
    (await this.api.getBrandingProgress(this.data.eventId)).subscribe({
      next: (res: any) => {
        const result = res.result;

        this.ngZone.run(() => {
          // Use values as-is from API
          this.total = result.total || 0;
          this.processed = result.processed || 0;
          this.skipped = result.skipped || 0;
          
          // Calculate percentage based on (processed + skipped) out of total
          if (this.total > 0) {
            this.progress = Math.round(((this.processed + this.skipped) / this.total) * 100);
          } else {
            this.progress = 0;
          }
          
          this.progressStatus = result.status;
        });
        // console.log('Branding progress:', res.result); //__CONSOLE_LOG__
        // Stop polling when done
        if (result.status === 'done' || this.progress >= 100) {
          clearInterval(this.polling);
          this.progress = 100;

          // Optional: let progress bar visually fill before closing
          setTimeout(() => this.dialogRef.close(), 1000);
        }
      },
      error: (err: any) => console.error('Error fetching branding progress', err)
    });
  }

  startPolling() {
    // Fetch immediately on start
    this.fetchProgress();
    
    // Then poll every 4 seconds
    this.polling = setInterval(() => {
      this.fetchProgress();
    }, 4000);
  }

  // startPolling() {
  //   this.polling = setInterval(async () => {
  //     try {
  //       const res: any = await firstValueFrom(await this.api.getBrandingProgress(this.data.eventId));
  //       // console.log('Branding progress:', res.result); //__CONSOLE_LOG__

  //       // Update UI inside Angular zone
  //       this.ngZone.run(() => {
  //         let result = res.result;
  //         this.processed = result.processed;
  //         this.total = result.total;
  //         this.progress = result.percent;
  //         this.progressStatus = result.status;
  //         this.cdr.detectChanges(); // Manually trigger change detection
  //       });

  //       // Stop polling when done
  //       if (res.result.status === 'done' || res.result.percent >= 100) {
  //         if (this.polling) clearInterval(this.polling);
  //         this.progress = 100; // ensure progress bar reaches 100%
  //         setTimeout(() => this.dialogRef.close(), 1000)
  //       }

  //     } catch (err) {
  //       console.error('Error fetching branding progress', err);
  //     }
  //   }, 3000); // poll every 3 seconds
  // }

}